import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { CollectionDestinationComponent } from './collection-destination.component';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { ManageLibraryCollectionFolderModule } from '../manage-library-collection-folder/manage-library-collection-folder.module';
import {
	FolderTreeSelectComponent
} from '@go-modules/components/library/manage-library-collection-folder/folder-tree-select/folder-tree-select.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		A11yModule,
		FocusOnFirstInvalidFieldModule,
		ManageLibraryCollectionFolderModule,
		FolderTreeSelectComponent
	],
	declarations: [
		CollectionDestinationComponent
	],
	exports: [
		CollectionDestinationComponent
	]
})
export class CollectionDestinationModule {}
